import {Component, Input} from '@angular/core';


@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  imports: [],
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent {
  @Input() isLoadingAlternatives: boolean = false;
  @Input() showInitialLoading: boolean = false;
}
